import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IDomain, IOrganisationConfig, IOrganisationTag, ITheme } from 'types/domain/organisation';
import { IKeyArray } from 'types/IKeyArray';
import { GenericStatus } from 'types/domain/base';
import { IEntityReducer } from 'core/reducers/entities';
import { ISessionReducer } from 'core/slices/session';

const entity = (state: RootState) => state.entity.present;
const session = (state: RootState) => state.session;

export const selectDomain = createSelector([entity, session], (entity: IEntityReducer, session: ISessionReducer) => {
  const domain: IDomain = entity[EntityTypes.DOMAIN][session.domainId];

  return domain;
});
